import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import {
  getUserDetailsdata,
  GetAllUserDeatailsdata,
} from "../../../Services/Admin/Addmin";
// import { getAdminName, getBalanceStatementsApi } from "../../../Services/Superadmin/Superadmin";

import { Link } from "react-router-dom";
import { ArrowLeftRight, Eye, RotateCcw } from "lucide-react";
import {
  getAdminName,
  switchOrderType,
  getBalanceStatementsApi,
} from "../../../Services/Superadmin/Superadmin";
import socket from "../../../Utils/socketClient";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const AllUserDetails = () => {
  const [data, setData] = useState([]);
  const [userName, setUserName] = useState([]);
  const [Userid, setUserId] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [userNameList, setUserNameList] = useState([]);
  const [userNamed, setUserNamed] = useState("");
  const [status, setStatus] = useState("");
  const [input, setInput] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [showBalanceModal, setShowBalanceModal] = useState(false);
  const [selectedUserBalance, setSelectedUserBalance] = useState([]);

  const [type, setType] = useState("USD");

  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;
  const userdata = getUserFromToken();

  const handlerefresh = () => {
    setInput("");
    setStatus("");
    setUserNamed("");
    setUserId("");
  };

  const handleExport = () => {
    if (!data || data.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Data",
        text: "No data available to export.",
      });
      return;
    }

    const excelData = data.map((item, index) => {
      const rowData = {
        "S.No": index + 1,
        "UserName": item.UserName || "-",
        "Total Credit": Number(item.totalCredit || 0).toFixed(2),
        "Total Debit": Number(item.totalDebit || 0).toFixed(2),
        "Remaining Balance": Number(item.Balance || 0).toFixed(2),
        "Total Brokerage": Number(item.totalBrokerage || 0).toFixed(2),
        "Realized P&L": Number(item.realizedPL || 0).toFixed(2),
        "Unrealized P&L": Number(item.unrealizedPL || 0).toFixed(2),
      };

      if (type === "INR") {
        rowData["Total Deposit"] = Number(item.totalDeposit || 0).toFixed(2);
        rowData["Total Withdrawal"] = Number(item.totalWithdrawal || 0).toFixed(2);
      }

      return rowData;
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users Details");
    XLSX.writeFile(workbook, `Users_Details_${type}.xlsx`);
  };





  const handlePageChange = (newPage) => {
    if (newPage < 1) return;
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newLimit) => {
    setRowsPerPage(newLimit);
    setPage(1); // reset page when limit changes
  };

  useEffect(() => {
    fetchUserList();
  }, [Userid, userNamed, input, status, type, page, rowsPerPage]);





  // const loadDropDownUsers = async () => {
  //   try {
  //     const res = await GetAllUserDeatailsdata({ adminId: userdata?.user_id });
  //     if (res?.status) {
  //       setUserNameList(res.data);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };



  const fetchUserList = async () => {
    try {

      const data = {
        adminId: userdata?.user_id,
        userId: userNamed || "",
        status: Number(status),
        input: Number(input) || "",
        page: page,
        limit: rowsPerPage
      };

      let response;
      if (type === "INR") {
        response = await getUserDetailsdata(data);
      } else {
        response = await GetAllUserDeatailsdata(data);

      }

      if (response?.status) {

        let list = [];
        if (type === "INR") {
          list = response.allUsers || [];
        } else {
          list = response.userList || [];
        }

        setUserNameList(list);
        setData(response.data);
        setTotalPages(response?.pagination?.totalPages || 1);
      }

      else {
        setUserNameList([]);
        setData([]);
        setTotalPages(1);
      }
    } catch (error) {
      console.error("User list fetch error:", error);
    }
  };


  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ row, index }) => {
        return (page - 1) * rowsPerPage + (index + 1);
      }
    },
    { Header: "UserName", accessor: "UserName" },

    {
      Header: "Total Credit",
      accessor: "totalCredit",
      Cell: ({ row }) => Number(row.totalCredit || 0).toFixed(2),
    },

    ...(type === "INR" ? [
      {
        Header: "Total Deposit",
        accessor: "totalDeposit",
        Cell: ({ row }) => Number(row.totalDeposit || 0).toFixed(2),
      }
    ] : []),

    {
      Header: "Total Debit",
      accessor: "totalDebit",
      Cell: ({ row }) => Number(row.totalDebit || 0).toFixed(2),
    },

    ...(type === "INR" ? [
      {
        Header: "Total Withdrawal",
        accessor: "totalWithdrawal",
        Cell: ({ row }) => Number(row.totalWithdrawal || 0).toFixed(2),
      }
    ] : []),

    {
      Header: "Remaining Balance",
      accessor: "Balance",
      Cell: ({ row }) => Number(row.Balance || 0).toFixed(2),
    },

    { Header: "Total Brokerage", accessor: "totalBrokerage" },

    {
      Header: "Realized P&L",
      accessor: "realizedPL",
      Cell: ({ row }) => {
        const value = Number(row.realizedPL || 0);
        return (
          <span style={{ color: value < 0 ? "red" : "green" }}>
            {value.toFixed(2)}
          </span>
        );
      },
    },

    {
      Header: "Unrealized P&L",
      accessor: "unrealizedPL",
      Cell: ({ row }) => {
        const value = Number(row.unrealizedPL || 0);
        return (
          <span style={{ color: value < 0 ? "red" : "green" }}>
            {value.toFixed(2)}
          </span>
        );
      },
    },

    {
      Header: "Trade History",
      accessor: "Trade History",
      Cell: ({ row }) => (
        <Link to={`/admin/User-tradehistory/${row._id}`}>
          <Eye style={{ cursor: "pointer", color: "#141414ff" }} />
        </Link>
      ),
    },

    {
      Header: "Transition History",
      accessor: "view",
      Cell: ({ row }) => {
        const userId = row._id;

        return (
          <button
            className="btn btn-sm btn-primary"
            onClick={async () => {
              const res = await getBalanceStatementsApi({ userId });

              if (res.status) {
                setSelectedUserBalance(res.data);
              } else {
                setSelectedUserBalance([]);
              }

              setShowBalanceModal(true);
            }}
          >
            View
          </button>
        );
      },
    },
  ];


  return (
    <div className="container-fluid mt-5 ">
      <div className="row">
        <div className="col-lg-12">
          <div className="card transaction-table custom-bg">
            <div className="card-header border-0 flex-wrap  d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center justify-content-between w-100">
                {/* Left Side */}
                <h4 className="card-title ">All Users</h4>

                {/* Right Side */}
                <div className="wallet-tabs">
                  <div className="btn-group " role="group">
                    {TokenData?.market.includes(0) && (
                      <button
                        type="button"
                        className={`btn ${type === "USD" ? "btn-primary" : "btn-outline-primary"
                          }`}
                        onClick={() => setType("USD")}
                      >
                        <i className="fas fa-dollar-sign me-2"></i>
                        USD Wallet
                      </button>
                    )}
                    {TokenData?.market.includes(1) && (
                      <button
                        type="button"
                        className={`btn ${type === "INR" ? "btn-primary" : "btn-outline-primary"
                          }`}
                        onClick={() => setType("INR")}
                      >
                        <i className="fas fa-rupee-sign me-2"></i>
                        INR Wallet
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="tab-content" id="myTabContent1">
                <div
                  className="tab-pane fade show active"
                  id="Week"
                  role="tabpanel"
                  aria-labelledby="Week-tab"
                >
                  <div className="row gx-3 gy-2 p-3 ms-3">
                    {/* <div className="col-md-3">
                      <label className="fw-bold mb-1">Search</label>
                      <select
                        className="form-select"
                        onChange={(e) => {
                          setUserNamed(e.target.value);
                        }}
                        value={userNamed}
                      >
                        <option value="">Select a user</option>
                        {userNameList?.map((user, index) => (
                          <option key={index} value={user._id}>
                            {user.UserName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="fw-bold mb-1">🛡️ Select</label>
                      <select
                        className="form-select"
                        onChange={(e) => setStatus(e.target.value)}
                        value={status}
                      >
                        <option value="">Select</option>
                        <option value="0">Less Than</option>
                        <option value="1">Greater Than</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="fw-bold mb-1">Enter Value</label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter number"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                      />
                    </div>
                    <div className="col-md-2  mt-5 ">
                      <RotateCcw onClick={handlerefresh} />
                    </div> */}
                    <div className="d-flex align-items-end justify-content-between w-100">
                      {/* LEFT SIDE */}
                      <div className="d-flex align-items-end gap-4 flex-wrap">
                        {/* USER SELECT */}
                        <div className="">
                          <label className="fw-bold mb-1">👤 User</label>
                          {/* <select
                            className="form-select"
                            style={{ height: "40px", width: "160px" }}
                            onChange={(e) => setUserNamed(e.target.value)}
                            value={userNamed}
                          >
                            <option value="">Select a user</option>
                            {userNameList?.map((user, index) => (
                              <option key={index} value={user._id}>
                                {user.UserName}
                              </option>
                            ))}
                          </select> */}
                          <select
                            className="form-select"
                            style={{ height: "40px", width: "160px" }}
                            onChange={(e) => setUserNamed(e.target.value)}
                            value={String(userNamed)}
                          >
                            <option value="">Select a user</option>
                            {userNameList?.map((user, index) => (
                              <option key={index} value={String(user._id)}>
                                {user.UserName}
                              </option>
                            ))}
                          </select>

                        </div>

                        {/* STATUS SELECT */}
                        <div>
                          <label className="fw-bold mb-1">🛡️ Select</label>
                          <select
                            className="form-select"
                            style={{ height: "40px", width: "160px" }}
                            onChange={(e) => setStatus(e.target.value)}
                            value={status}
                          >
                            <option value="">Select</option>
                            <option value="0">Less Than</option>
                            <option value="1">Greater Than</option>
                          </select>
                        </div>

                        {/* ENTER VALUE */}
                        <div>
                          <label className="fw-bold mb-1">Enter Value</label>
                          <input
                            type="number"
                            className="form-control"
                            style={{ height: "40px", width: "160px" }}
                            placeholder="Enter number"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* RIGHT SIDE BUTTONS */}
                      <div className="d-flex gap-2 align-items-end">
                        <button onClick={handlerefresh} className="refresh-btn">
                          <RotateCcw size={20} /> Clear Filters
                        </button>
                        <button
                          onClick={handleExport}
                          className="btn btn-success d-flex align-items-center gap-2"
                          style={{ height: "40px", borderRadius: "10px", fontWeight: "600", fontSize: "14px" }}
                        >
                          <i className="fas fa-file-excel" /> Export Excel
                        </button>
                      </div>

                    </div>
                  </div>

                  <div className="px-3">
                    <Table
                      columns={columns}
                      data={data}
                      page={page}
                      totalPages={totalPages}
                      initialRowsPerPage={rowsPerPage}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsPerPageChange}
                    />


                    {/* <div
                      className="d-flex align-items-center"
                      style={{
                        marginBottom: "20px",
                        marginLeft: "20px",
                        marginTop: "-48px",
                      }}
                    >
                      Rows per page:
                      <select
                        className="form-select ml-2"
                        value={rowsPerPage}
                        onChange={(e) => setRowsPerPage(Number(e.target.value))}
                        style={{ width: "auto", marginLeft: "10px" }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div> */}

                    {showBalanceModal && (
                      <div
                        className="modal fade show"
                        style={{
                          display: "block",
                          background: "rgba(0,0,0,0.5)",
                        }}
                      >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable">

                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">
                                User Balance Statement
                              </h5>
                              <button
                                className="btn-close"
                                onClick={() => setShowBalanceModal(false)}
                              ></button>
                            </div>

                            <div className="modal-body">
                              <div className="table-responsive">
                                <table className="table table-bordered">
                                  <thead className="table-dark">
                                    <tr>
                                      <th>Date</th>
                                      <th>Type</th>
                                      <th>Amount</th>
                                      <th>Balance</th>
                                      <th>message</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {selectedUserBalance?.map((item, index) => (
                                      <tr key={index}>
                                        <td>
                                          {item?.createdAt
                                            ? new Date(
                                              item.createdAt
                                            ).toLocaleString()
                                            : "-"}
                                        </td>
                                        <td>{item?.type || "-"}</td>
                                        <td>{item?.Amount || 0}</td>
                                        <td>{item?.Balance || 0}</td>
                                        <td>{item?.message || "-"}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>

                            <div className="modal-footer">
                              <button
                                className="btn btn-secondary"
                                onClick={() => setShowBalanceModal(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllUserDetails;
